(function(){
  var d=document,R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var $=function(s,c){return (c||d).querySelector(s)},$$=function(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))};
  d.documentElement.classList.add('js');
  if(window.Shopify&&Shopify.designMode)d.documentElement.classList.add('design');

  /* Scroll reveal */
  var io='IntersectionObserver' in window?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.1,rootMargin:'0px 0px -30px 0px'}):null;
  function reveal(r){$$('[data-reveal]:not(.in)',r).forEach(function(el){io?io.observe(el):el.classList.add('in')})}
  reveal();

  /* Drawers */
  function open(id){var el=$(id);if(!el)return;el.classList.add('open');el.setAttribute('aria-hidden','false');d.body.classList.add('lock')}
  function closeAll(){$$('.drawer.open').forEach(function(el){el.classList.remove('open');el.setAttribute('aria-hidden','true')});d.body.classList.remove('lock')}
  d.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll()});

  /* Cart */
  function post(url,body,json){return fetch(R+url,{method:'POST',headers:json?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},body:json?JSON.stringify(body):body}).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})}
  function refresh(){
    return fetch(R+'?sections=cart-drawer').then(function(r){return r.json()}).then(function(j){
      var t=d.createElement('div');t.innerHTML=j['cart-drawer'];
      var n=$('.drawer-inner',t),o=$('#CartDrawer .drawer-inner');
      if(n&&o)o.innerHTML=n.innerHTML;
      var s=$('[data-cart-count-src]',t);
      if(s){var c=s.getAttribute('data-cart-count-src');$$('[data-cart-count]').forEach(function(b){b.textContent=c;b.setAttribute('data-zero',c==='0');b.classList.remove('bump');void b.offsetWidth;b.classList.add('bump')})}
    });
  }

  d.addEventListener('click',function(e){
    var t=e.target.closest('[data-open-cart],[data-open-menu],[data-close],[data-quick-add],[data-add],[data-qty],[data-step],[data-thumb]');
    if(!t)return;
    if(t.hasAttribute('data-open-cart')){e.preventDefault();refresh().then(function(){open('#CartDrawer')});return}
    if(t.hasAttribute('data-open-menu')){open('#MenuDrawer');return}
    if(t.hasAttribute('data-close')){closeAll();return}
    if(t.hasAttribute('data-quick-add')){
      var fd=new FormData();fd.append('id',t.getAttribute('data-quick-add'));fd.append('quantity',1);
      var old=t.textContent;t.textContent='Adding…';
      post('cart/add.js',fd).then(refresh).then(function(){t.textContent='Added ✓';t.classList.add('done');open('#CartDrawer');setTimeout(function(){t.textContent=old;t.classList.remove('done')},1800)}).catch(function(err){t.textContent=old;alert(err.description||'Could not add to cart')});
      return;
    }
    if(t.hasAttribute('data-add')){
      var f=t.closest('form');if(!f)return;e.preventDefault();
      var er=$('[data-error]',f);if(er)er.textContent='';
      t.classList.add('loading');t.disabled=true;
      post('cart/add.js',new FormData(f)).then(refresh).then(function(){open('#CartDrawer')}).catch(function(err){if(er)er.textContent=err.description||'Could not add to cart'}).then(function(){t.classList.remove('loading');t.disabled=false});
      return;
    }
    if(t.hasAttribute('data-qty')){
      post('cart/change.js',{line:+t.getAttribute('data-line'),quantity:+t.getAttribute('data-to')},true).then(refresh);return;
    }
    if(t.hasAttribute('data-step')){
      var i=$('input[name=quantity]',t.parentNode);i.value=Math.max(1,(+i.value||1)+(+t.getAttribute('data-step')));return;
    }
    if(t.hasAttribute('data-thumb')){selectThumb(t)}
  });

  /* Product page */
  function selectThumb(t){
    var box=t.closest('[data-product]'),img=$('[data-main-img]',box);
    if(img){img.src=t.getAttribute('data-thumb');img.removeAttribute('srcset')}
    $$('.thumb',box).forEach(function(x){x.classList.toggle('on',x===t)});
  }
  function initProduct(box){
    var vs=$('[data-variants]',box);if(!vs)return;
    var V=JSON.parse(vs.textContent),form=$('form',box);
    $$('.opt input',box).forEach(function(r){r.addEventListener('change',update)});
    var main=$('.gal-main',box);
    if(main)main.addEventListener('mousemove',function(e){var b=main.getBoundingClientRect();main.style.setProperty('--x',((e.clientX-b.left)/b.width*100)+'%');main.style.setProperty('--y',((e.clientY-b.top)/b.height*100)+'%')});
    function update(){
      var sel=[];$$('.opt',box).forEach(function(fs){var c=$('input:checked',fs);sel.push(c?c.value:null)});
      var v=V.filter(function(x){return sel.every(function(s,i){return s===null||x.o[i]===s})})[0];
      var add=$('[data-add]',box),buy=$('[data-buy]',box),pr=$('[data-price]',box),cp=$('[data-compare]',box);
      if(!v){if(add){add.disabled=true;$('span',add).textContent='Unavailable'}if(buy)buy.disabled=true;return}
      $('[data-vid]',box).value=v.id;
      if(pr)pr.innerHTML=v.price;
      if(cp){cp.innerHTML=v.cmp;cp.style.display=v.cmp?'':'none'}
      if(add){add.disabled=!v.av;$('span',add).textContent=v.av?'Add to cart':'Sold out'}
      if(buy)buy.disabled=!v.av;
      if(v.img){var th=$('.thumb[data-mid="'+v.img+'"]',box);if(th)selectThumb(th)}
      if(history.replaceState)history.replaceState(null,'','?variant='+v.id);
    }
  }
  function initRecs(){
    $$('[data-recs]:not([data-done])').forEach(function(el){
      el.setAttribute('data-done','1');
      fetch(el.getAttribute('data-url')).then(function(r){return r.text()}).then(function(h){
        var t=d.createElement('div');t.innerHTML=h;var n=$('[data-recs]',t);
        if(n&&n.innerHTML.trim()){el.innerHTML=n.innerHTML;reveal(el)}else{el.closest('section').style.display='none'}
      });
    });
  }
  function init(r){
    $$('[data-product]',r).forEach(initProduct);initRecs();reveal(r);
    $$('[data-auto]',r).forEach(function(f){f.addEventListener('change',function(){f.submit()})});
  }
  init(d);
  d.addEventListener('shopify:section:load',function(e){init(e.target)});

  /* Header shadow */
  var h=$('[data-header]');
  if(h)window.addEventListener('scroll',function(){h.classList.toggle('scrolled',window.scrollY>10)},{passive:true});
})();
